
import {fromEvent as observableFromEvent, merge as observableMerge,  Observable ,  Subscription } from 'rxjs';

import {pluck, filter, debounceTime} from 'rxjs/operators';
import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import * as Opentip from '../../scripts/tooltip.js';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

// const Opentip: any = require('../scripts/tooltip.js');

@AutoUnsubscribe()
@Directive({
    selector: '[tooltip] , [popover]',
})
export class TooltipDirective implements OnInit , OnDestroy {

    @Input() public tooltip: string; // Template
    @Input() public popover: string; // Template
    @Input() public direction: string = 'top'; // Direção do tooltip se houver;
    @Input() public target: any = true; // Target se houver
    @Input() public isInsideModal: boolean = false; // Verifica se o tooltip está dentro de um modal
    @Input() public showMobile: boolean = true;
    @Input() public background: string = '#FFF';
    @Input() public customClass: string = '';
    @Input() public hasButton: boolean = false; // Verifica se o tooltip possui no seu conteúdo, um botão

    private eventsSubscriptions = new Subscription();
    private nativeElement: HTMLInputElement;
    private tooltipClass: any = null;
    private active: boolean = false;

    constructor(
        public element: ElementRef,
    ) {
        this.nativeElement = this.element.nativeElement;
    }

    public isMobile(): boolean {
        return window.innerWidth <= 1023;
    }

    public ngOnInit() {
        // Inicializar tooltip
        if (this.isMobile() && !this.showMobile ) {
            this.tooltipClass = null;
            return;
        }

        this.tooltipClass = new Opentip(this.nativeElement, this.tooltipOptions());

        // Detectar eventos no tolltip
        const mouseEventSubscription = observableMerge(
            observableFromEvent(this.nativeElement, 'mouseover'),
            observableFromEvent(this.nativeElement, 'mouseout'),
            observableFromEvent(this.nativeElement, 'click'),
        )
        .pipe(
            pluck('type'),
            debounceTime(100),
        )
        .subscribe((event: string) => {
            if (this.hasButton) {
                if (event === 'click' && !this.active) {
                    this.tooltipClass.setContent(this.tooltip || this.popover);

                    if (!this.tooltip && !this.popover) {
                        this.tooltipClass.hide();
                        this.active = false;
                        return;
                    }

                    this.tooltipClass.show();
                    this.active = true;
                } else if (['mouseover', 'mouseout'].includes(event) && this.active) {
                    this.tooltipClass.show();
                    this.active = true;
                    return;
                } else {
                    this.tooltipClass.hide();
                    this.active = false;
                    return;
                }
            } else {
                // Eventos para exibir o tooltip
                if (['mouseover', 'click'].includes(event) && !this.active) {

                    this.tooltipClass.setContent(this.tooltip || this.popover);

                    if (!this.tooltip && !this.popover) {
                        this.tooltipClass.hide();
                        this.active = false;
                        return;
                    }

                    this.tooltipClass.show();
                    this.active = true;
                } else {
                    this.tooltipClass.hide();
                    this.active = false;
                }
            }
        });

        this.eventsSubscriptions.add(mouseEventSubscription);

        // Detectar eventos fora do tooltip
        const windowEventsSubscription = observableMerge(
            observableFromEvent(window, 'click'),
            observableFromEvent(window, 'touchend'),
        )
        .pipe(filter((event: Event) => event.target !== this.nativeElement))
        .subscribe((event: Event) => {
            this.tooltipClass.hide();
            this.active = false;
        });

        this.eventsSubscriptions.add(windowEventsSubscription);

    }

    // Gerar o tooltip
    public tooltipOptions(): any {
        return {
            extends: 'glass',
            className: `${this.isInsideModal ? 'modal' : 'tooltip'} ${this.customClass}`,
            fixed: true,
            tipJoint: this.direction,
            shadowBlur: 20,
            stemLength: 15,
            shadowOffset: [1, 1],
            stemBase: 15,
            background:  this.background,
            borderColor: 'transparent',
            borderRadius: 0,
            removeElementsOnHide: true,
            target: this.target,
            showOn: null,
        };
    }

    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    // tslint:disable-next-line: no-empty
    public ngOnDestroy() { }
}
